// Base API URL - can be changed based on environment
// Determine if we're in production environment
const isProduction = process.env.NODE_ENV === 'production';

// Base API URL - use environment variable if available, otherwise use appropriate URL based on environment
const BASE_URL = process.env.REACT_APP_API_URL || 
                    (isProduction ? 'https://bangalorevaluers.org/api/api' : 'http://127.0.0.1:5000/api');

// const BASE_URL = 'http://127.0.0.1:5000/api';

// Export BASE_URL for use in components
export const API_BASE_URL = BASE_URL;

// Public endpoints (no authentication required)
export const PUBLIC_URLS = {
  LOGIN: `${BASE_URL}/member/login`,
  FORGOT_PASSWORD: `${BASE_URL}/forgot-password`,
  RESET_PASSWORD: `${BASE_URL}/reset-password`,
  VERIFY_EMAIL: `${BASE_URL}/member/verify-email`,
  EVENTS: `${BASE_URL}/events`,
  PROGRAMS: `${BASE_URL}/programs`,
  CONTACT: `${BASE_URL}/contact`,
  MEMBERSHIP_PLANS: `${BASE_URL}/membership-plans`,
  RESOURCES: `${BASE_URL}/resources`, 
  PROFESSIONALS: `${BASE_URL}/member/professionals`,
  GALLERY: `${BASE_URL}/gallery`,
  GALLERY_PHOTOS: `${BASE_URL}/gallery/photos`,
  GALLERY_VIDEOS: `${BASE_URL}/gallery/videos`,
  PROFILE: `${BASE_URL}/member/profile`,
  CHANGE_PASSWORD: `${BASE_URL}/member/change-password`,
  RENEW_MEMBERSHIP: `${BASE_URL}/member/renew-membership`,
  NEWS: `${BASE_URL}/news`,
  OFFICE_BEARERS: `${BASE_URL}/office-bearers`,
  OFFICE_BEARERS_PAST: `${BASE_URL}/office-bearers/past`,
  OFFICE_BEARERS_PAST_BY_YEAR: `${BASE_URL}/office-bearers/past/by-year`,
  OFFICE_BEARER_DETAIL: (id) => `${BASE_URL}/office-bearers/${id}`,
  PROGRAM_REGISTRATION: (id) => `${API_BASE_URL}/public/programs/${id}/register`,
  PAYMENT_VERIFICATION: `${API_BASE_URL}/public/payment/verify`
};

// Member endpoints (authentication required)
export const MEMBER_URLS = {
  REGISTER: `${BASE_URL}/member/register`,
  PROFILE: `${BASE_URL}/member/profile`,
  UPDATE_PROFILE: `${BASE_URL}/member/profile`,  // Updated to match backend
  CHANGE_PASSWORD: `${BASE_URL}/member/change-password`,
  DASHBOARD: `${BASE_URL}/member/dashboard`,
  EVENTS: `${BASE_URL}/member/events`,
  PROGRAMS: `${BASE_URL}/member/programs`,
  REGISTRATIONS: `${BASE_URL}/member/registrations`,
  CERTIFICATES: `${BASE_URL}/member/certificates`,
  PAYMENTS: `${BASE_URL}/member/payments`,
  RENEW_MEMBERSHIP: `${BASE_URL}/member/renew-membership`,
  VERIFY_REGISTRATION: `${BASE_URL}/member/verify-registration`  // Fixed path to match backend route
};

// Admin endpoints (admin authentication required)
export const ADMIN_URLS = {
  DASHBOARD: `${BASE_URL}/admin/dashboard`,
  MEMBERS: `${BASE_URL}/admin/members`,
  MEMBER_DETAIL: (id) => `${BASE_URL}/admin/members/${id}`,
  EVENTS: `${BASE_URL}/admin/events`,
  PROGRAMS: `${BASE_URL}/admin/programs`,
  PROGRAM_DETAIL: (id) => `${BASE_URL}/admin/programs/${id}`,
  PAYMENTS: `${BASE_URL}/admin/payments`,
  PAYMENT_DETAIL: (id) => `${BASE_URL}/admin/payments/${id}`,
  RESOURCES: `${BASE_URL}/admin/resources`,
  RESOURCE_DETAIL: (id) => `${BASE_URL}/admin/resources/${id}`,
  GALLERY: `${BASE_URL}/admin/gallery`,
  GALLERY_ITEM: (id) => `${BASE_URL}/admin/gallery/${id}`,
  SETTINGS: `${BASE_URL}/admin/settings`,
  MEMBERSHIP_PLANS: `${BASE_URL}/admin/membership-plans`,
  MEMBERSHIP_PLAN_DETAIL: (id) => `${BASE_URL}/admin/membership-plans/${id}`,
  DISCOUNTS: `${BASE_URL}/admin/discounts`,
  DISCOUNT_DETAIL: (id) => `${BASE_URL}/admin/discounts/${id}`,
  OFFICE_BEARERS: `${BASE_URL}/admin/office-bearers`,
  OFFICE_BEARER_DETAIL: (id) => `${BASE_URL}/admin/office-bearers/${id}`,
  OFFICE_BEARER_REORDER: (id) => `${BASE_URL}/admin/office-bearers/${id}/reorder`,
  OFFICE_BEARER_UPLOAD_IMAGE: `${BASE_URL}/admin/office-bearers/upload-image`
};

// Helper function to get proper resource URL
export const getResourceUrl = (url) => {
  if (!url) return '';
  
  // If URL starts with http/https, return as is (external URL)
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If URL starts with /uploads, construct backend static URL
  if (url.startsWith('/uploads')) {
    return `${API_BASE_URL.replace('/api/api', '/api/static')}${url}`;
  }
  
  // Default fallback - assume it's a relative path to backend
  return `${API_BASE_URL.replace('/api', '')}${url.startsWith('/') ? url : '/' + url}`;
};